import styled from 'styled-components';

const ComponentDescription = styled.div`
font-size: 1em;
display: block;
line-height: 1.2em;
margin-top: .5em;
`;

export default ComponentDescription;